import { MenuItem } from '@mui/material';
import CreateMaterialRequestApp from "../Functionality/CreateMaterialRequestApp";
import {
    AddIcon,
    CleanIcon, DeleteIconsOptions, DownloadIcon,
    PersonChipBlack,
    TrashOutlineIcon
} from "../../../../components/buttons/IconButtons";
import HeadTittle from "../../../../components/HeadTittle";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import DivContainerBody from "../../../../components/DivContainerBody";
import DividerWithText from "../../../../components/DividerWithText";
import {CustomTextField} from "../../../../components/CustomTextField";
import {CustomSelectAndChildren} from "../../../../components/CustomSelectAndChildren";
import DeleteModal from "../../../Modals/DeleteModal";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import CustomAddChipSearch from "../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../enums/userTypeEnum";
import {userListToLabelEmailPhoneValue} from "../../../../Apis/functions";
import React from "react";
import {fileSize} from "../../../../constant/variable";
import CustomPhotoPickerMultiple from "../../../../components/PhotoPicker/CustomPhotoPickerMultiple";
import CustomCard from "../../../../components/CustomCard";
import {permissionObj} from "../../../../Helpers/permission";
import routes from "../../../../Routes/routes";
import {getUnitTransByName} from "../../Dining/Ingredients/Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateMaterialRequest = ({userTypeId}) => {
    const {
        t,
        DEV,
        isGuard,
        permission,
        navigate,
        emptyFields,
        emptyFieldsItems,
        materialRequest,
        handleChangeTemp,
        handleChange,
        photoPicker,
        setPhotoPicker,
        showDeleteModal,
        setShowDeleteModal,
        selectedLevelId,
        setSelectedLevelId,
        selectedEmployees,
        setSelectedEmployees,
        measurementUnitsAll,
        handleAdd,
        handleDeleteItem,
        resetForm,
        handleOnBack,
        handleAction
    } = CreateMaterialRequestApp({userTypeId});

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_READ) &&
        !permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_CREATE)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'create'}
                onBack={handleOnBack}
                divStack={
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cmr_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                resetForm();
                            }}
                        />
                    }
                >
                { (DEV || permission?.includes(permissionObj?.WEB_MATERIAL_REQUEST_CREATE)) &&
                    <ButtonAction
                        id='btn_cmr_create'
                        name={'create'}
                        className={'btn-icon-add'}
                        Icon={AddIcon}
                        onClick={() => {
                        handleAction();
                    }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className={'col-12'}>
                    <DividerWithText title={t('data')} />
                </div>

                <div className={'row mt-3'}>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomTextField
                            required={true}
                            id={'slt_cmr_title'}
                            name={'title'}
                            trans={'request_title'}
                            length={128}
                            value={materialRequest?.title}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomTextField
                            required={true}
                            id={'slt_cmr_code'}
                            name={'code'}
                            trans={'folio'}
                            length={128}
                            value={materialRequest?.code}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                        />
                    </div>
                    <div className={"col-12"}>
                        <CustomAddChipSearch
                            id="slt_cmr_search_employees"
                            selectedList={selectedEmployees}
                            setSelectedList={setSelectedEmployees}
                            userTypeIdsSearch={[
                                USER_TYPE_MODEL.EMPLOYEE
                            ]}
                            disabled={false}
                            label="requested_by"
                            required={true}
                            hideButton={true}
                            keyId={"userId"}
                            showSubSection={true}
                            sanitizeDataList={userListToLabelEmailPhoneValue}
                            Icon={PersonChipBlack}
                            emptyFields={emptyFields}
                        />
                    </div>
                    <div className='col-12'>
                        <CustomTextField
                            id={'txt_cmr_vehicle_information'}
                            length={512}
                            name={'vehicleInformation'}
                            trans={'vehicle_information'}
                            value={materialRequest.vehicleInformation}
                            type={'text'}
                            disabled={false}
                            onChange={handleChange}
                            multiline={true}
                        />
                    </div>
                </div>

                <div className={'col-12'}>
                    <DividerWithText title={t('materials')} spacing={'mb-4'} />
                </div>

                <div className={"col-12 mb-4"}>
                    <CustomCard classCard="card-border-8px" >
                        { materialRequest?.items?.map((e, index) => {

                            return <div className={"col-12 p-0 mb-3"}>
                                <div className={"row border-full-shades-300 background-shades-50 border-radius-8px input-padding-top"}>
                                    <div className='col-sm-12 col-md-4 px-sm-3 pl-md-3 pr-md-3'>
                                        <CustomTextField
                                            required={true}
                                            id={'slt_cmr_name'}
                                            name={'name'}
                                            trans={'name'}
                                            length={128}
                                            value={e?.name}
                                            onChange={(e) => handleChangeTemp(e, index)}
                                            emptyFields={emptyFieldsItems}
                                        />
                                    </div>
                                    <div className='col-sm-12 col-md-4 px-sm-3 pl-md-0 pr-md-3'>
                                        <CustomTextField
                                            required={true}
                                            id={'slt_cmr_quantity'}
                                            type={"number"}
                                            name={'quantity'}
                                            trans={'quantity'}
                                            length={9}
                                            value={e?.quantity}
                                            onChange={(e) => handleChangeTemp(e, index)}
                                            emptyFields={emptyFieldsItems}
                                        />
                                    </div>
                                    <div className='col-sm-12 col-md-4 px-sm-3 pl-md-0 pr-md-3'>
                                        <div className={"d-flex"}>
                                            <div className={"w-100"}>
                                                <CustomSelectAndChildren
                                                    id='slt_cmr_measurement_unit_id'
                                                    name='measurementUnitId'
                                                    trans='unit'
                                                    label='lbl_cmr_measurement_unit_id'
                                                    showNoSelectionOption={false}
                                                    required={true}
                                                    value={e?.measurementUnitId}
                                                    onChange={(e) => handleChangeTemp(e, index)}
                                                    emptyFields={emptyFieldsItems}
                                                >
                                                    {measurementUnitsAll?.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                            {t(getUnitTransByName(item.name))}
                                                        </MenuItem>
                                                    ))}
                                                </CustomSelectAndChildren>
                                            </div>

                                            { materialRequest?.items?.length > 1 &&
                                                <div className={"pl-3"}>
                                                    <ButtonIcon
                                                        id={'btn_cmr_delete'}
                                                        Icon={TrashOutlineIcon}
                                                        onClick={() => {
                                                            setSelectedLevelId(e);
                                                           setShowDeleteModal(true);
                                                        }}
                                                        className='btn-outlined-error-600 h-40px w-40px'
                                                        iconProps={'btn-icon-svg-24px'}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                        }

                        <div className='col-12 px-0'>
                            <ButtonAction
                                id='btn_cmr_add_new_material'
                                name='add_material'
                                Icon={AddIcon}
                                splitName={false}
                                className='btn-outlined-secondary-600-00'
                                disabled={false}
                                onClick={() => {
                                    handleAdd();
                                }}
                            />
                        </div>
                    </CustomCard>
                </div>

                <div className={'col-12'}>
                    <DividerWithText title={t('documentation')} spacing={'mb-4'} />
                </div>

                <div className={"row mt-3 mb-60px"}>
                    <div className={'col-12'}>
                        <CustomPhotoPickerMultiple
                            id='fu_cmr_file'
                            photoPickerFile={photoPicker}
                            setPhotoPickerFile={setPhotoPicker}
                            accept={{ ...FILE_TYPE.FILES, size: fileSize }}
                            showBtnDeleteItemGallery={true}
                            showBtnCamera={false}
                            deleteIcon={DeleteIconsOptions}
                            downloadIcon={DownloadIcon}
                            showBtnDownload={true}
                            apiDelete={false}
                            disabled={false}
                            required={true}
                            emptyFields={emptyFields && photoPicker?.listFiles?.length === 0}
                        />
                    </div>
                </div>
            </DivContainerBody>

            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                data={[selectedLevelId]}
                onClickFn={() => {
                    if (selectedLevelId !== null) {
                        handleDeleteItem(selectedLevelId);
                    }
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                title_modal={t('delete_material')}
                element_modal={t('material')}
            />
        </>
    );
};

export default CreateMaterialRequest;
